// Filter function for balances (used in useFilteredBalances)
export const BALANCE_FILTER = (balance: any) =>
    !(
        //(['["OTC"]', '["MM4"]'].includes(balance.business) && balance.is_prop === '["N"]') ||
        (
            balance.exchange &&
            (balance.exchange.includes('LOANS_TREASURY') ||
                balance.exchange.includes('TREASURYPOSITION') ||
                balance.subdesk !== 'Main' ||
                balance.exchange.includes('TREASURYPROP'))
        )
    );
// UI Configuration
export const APP_BAR_HEIGHT = 64;

// API Configuration
// Respect explicit REACT_APP_ENV from npm scripts first; hostname is only a fallback.
const getRuntimeEnv = () => {
    const env = (process.env.REACT_APP_ENV || '').toLowerCase();

    if (env === 'local' || env === 'dev' || env === 'prod' || env === 'docker') {
        return env;
    }

    if (typeof window !== 'undefined') {
        const host = window.location.hostname.toLowerCase();

        if (host === 'localhost' || host === '127.0.0.1') {
            return 'local';
        }

        if (host.includes('.dev.')) {
            return 'dev';
        }
    }

    return 'local';
};

const getApiConfig = () => {
    const env = getRuntimeEnv();
    const configuredApiBase = process.env.REACT_APP_API_BASE_URL;

    if (configuredApiBase) {
        return {
            host: configuredApiBase.replace(/\/$/, ''),
            port: '',
        };
    }

    switch (env) {
        case 'dev':
            return {
                host: 'https://lux-xm-back-fmhhd7akd7byf2ct.switzerlandnorth-01.azurewebsites.net',
                port: '',
            };
        case 'prod':
            return {
                host: 'https://lux-xm-back-fmhhd7akd7byf2ct.switzerlandnorth-01.azurewebsites.net',
                port: '',
            };
        case 'docker':
            return {
                host: 'https://localhost',
                port: '3005',
            };
        case 'local':
        default:
            return {
                host: 'http://localhost',
                port: '8090',
            };
    }
};

const apiConfig = getApiConfig();

export const API_HOST = apiConfig.host;
export const API_PORT = apiConfig.port;
export const API_BASE = API_PORT ? `${API_HOST}:${API_PORT}` : `${API_HOST}`;

// Debug log to verify API config at runtime
console.log('🔧 [DEBUG] API Config:', {
    REACT_APP_ENV: process.env.REACT_APP_ENV,
    API_HOST,
    API_PORT,
    API_BASE,
});

// Legacy exports for backward compatibility
export const API_HOST_DEV = API_HOST;
export const API_PORT_DEV = API_PORT;
